import React, { createContext, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';
import type { ProgramId, TrialChoice } from '../types/content';
interface ProgramContextValue {
  activeId: ProgramId;
  setActiveId: (id: ProgramId) => void;
  trialChoice: TrialChoice;
  setTrialChoice: (choice: TrialChoice) => void;
}
const ProgramContext = createContext<ProgramContextValue | null>(null);
export function ProgramProvider({
  children
}: {
  children: ReactNode;
}) {
  const [activeId, setActiveId] = useState<ProgramId>('little-braves');
  const [trialChoice, setTrialChoice] = useState<TrialChoice>('not-sure');
  const value = useMemo(() => ({
    activeId,
    setActiveId,
    trialChoice,
    setTrialChoice
  }), [activeId, trialChoice]);
  return <ProgramContext.Provider value={value} data-id="element-378" data-mp="e2oeepoogvrn">{children}</ProgramContext.Provider>;
}
export function usePrograms() {
  const ctx = useContext(ProgramContext);
  if (!ctx) throw new Error('usePrograms must be used inside ProgramProvider');
  return ctx;
}